import React from 'react';

import CardDialog from '~/components/CardDialog';

import SopViewDialogContent from './SopViewDialogContent';
import type { SopConfigurationResponse } from './types';

interface OrgSopViewDialogProps {
  open: boolean;
  onClose: () => void;
  configuration: SopConfigurationResponse;
  organizationName: string;
}

const OrgSopViewDialog: React.FC<OrgSopViewDialogProps> = ({ open, onClose, configuration, organizationName }) => {
  if (!open) return null;

  const title = `${organizationName} Standard Operating Procedures`;

  return (
    <CardDialog
      isDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth={false}
      PaperProps={{
        style: { height: '70vh', width: '70vw' },
      }}
    >
      <SopViewDialogContent configuration={configuration} />
    </CardDialog>
  );
};

export default OrgSopViewDialog;
